let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsCrossedResult определяет структуру результата логической проверки на пересечение одного объекта другим
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsCrossedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsCrossedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsCrossedResult";
  }
}

module.exports = IsCrossedResult;